import { render, staticRenderFns } from "./AMonto.vue?vue&type=template&id=7df70f56"
import script from "./AMonto.vue?vue&type=script&lang=js"
export * from "./AMonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports